import React from 'react';
import { useCurrentBreakpointName } from 'react-socks';

const ViewOptions = (props) => {
    let currentBreakpoint = useCurrentBreakpointName(),
        views = ['month', 'week', 'list'];

    if (currentBreakpoint === 'mobile') {
        //views.splice(1, 1);
    }

    return (
        <div className={`queue-view-toggle ${currentBreakpoint}`}>
            <ul className={`multi-toggle ${currentBreakpoint}`} onClick={(e) => {
                let nextOption = e.target.dataset.option;

                props.toggleQueueView(nextOption);
            }}>
                {views.map((option, i) => {
                    let optionClass = 'toggle-option';

                    if (props.currentQueueView === option) {
                        optionClass += ' active';
                    }

                    return (
                        <li key={i} data-option={option} className={optionClass} role="button" aria-pressed={props.currentQueueView === option}>
                            {option}
                        </li>
                    )
                })}
            </ul>
        </div>
    );
}

export default ViewOptions;
